import { render, staticRenderFns } from "./waitList.vue?vue&type=template&id=cdfd4f9c&scoped=true"
import script from "./waitList.vue?vue&type=script&lang=js"
export * from "./waitList.vue?vue&type=script&lang=js"
import style0 from "./waitList.vue?vue&type=style&index=0&id=cdfd4f9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdfd4f9c",
  null
  
)

export default component.exports